import React from 'react';
import { FormattedMessage } from 'react-intl';

import { ActionablePlaceholder } from 'ui-components/components/display-grid/actionable-placeholder';

import { messages } from './messages';

/**
 * Placeholder component displayed when there are no purchase orders to show
 * Renders an ActionablePlaceholder with a title and description
 * @returns {JSX.Element} The rendered placeholder component
 */
export const PurchaseOrdersGridPlaceholder = () => {
  return (
    <ActionablePlaceholder
      description={<FormattedMessage {...messages.gridPlaceholderDescription} />}
      title={
        <FormattedMessage
          {...messages.gridPlaseholderTitle}
          values={{
            b: (chunks) => <b>{chunks}</b>,
          }}
        />
      }
    />
  );
};
